const axios = require('axios')
import { Message } from 'element-ui'

// import mockApi from './mockApi.js';
import qs from 'qs'

// const apiUrl = 'http://118.31.72.94:9500/prop/back'
// const apiUrl = 'http://47.97.254.63:9500/prop/back'
// const apiUrl = 'http://192.168.1.208:9500/prop/back'
// 打包前去掉这里的注释
 const apiUrl = 'https://www.nbzhwy.com/prop/back'
// const apiUrl = 'https://bell.nbzlit.com/prop/back'
// const apiUrl = 'http://127.0.0.1:9500/prop/back'

function getToken() {
  return localStorage.getItem('token')
}
const notNeedTokenUrl = [
  '/oss/manage?method=uploadImage',
  '/system/sms/getCode',
  '/api/index/login',
  '/api/login/register',
  '/api/applet/updateUserStatus',
  '/api/roleInfoEntity/saveRoleInfoEntity',
  '/api/login/loginH5'
]
// request拦截器，添加token
axios.interceptors.request.use(
  (config) => {
    if (config.headers && config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('application/x-www-form-urlencoded') > -1) {
      return config
    }
    //特殊处理,不需要传默认的token
    if (notNeedTokenUrl.indexOf(config.url) > -1) {
      return config
    } else {
      return config
    }
  },
  (error) => {
    console.error(error) // for debug
    Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (config) => {
    if (config.data.code === 400 || config.data.code === 900) {
      window.vm._router.replace({ name: 'login', params: { resetRouter: true, code: config.data.code } })
    } else {
      return config
    }
  },
  (error) => {
    return config
  }
)
/**
/**
 * 真实的请求处理
 */
function request(type, url, options, baseURL) {
  // notPageNation 为1时不分页
  // isPaging 为1时分页
  //下载请求单独处理
  let downloadUrl = [
    '/api/projectInfo/export',
    '/api/projectInfo/downloadFile',
    '/api/evaluationRecord/export',
    '/api/evaluationRecord/exportXls',
    '/api/evaluationBack/export',
    '/api/evaluationPlan/export',
    '/api/evaluationPlan/downloadFile',
    '/api/home/exportDetailed',
    '/api/home/exportEval',
    '/api/home/exportProjectCount',
    '/api/projectInfo/downloadMatchFile',
    '/api/evaluationStandard/downloadFile',
    '/api/evaluationRecord/exportByPlanId',
    '/api/evaluationBack/exportInfo',
    '/api/evaluationRecord/exportList'
  ]

  let importdUrl = ['/api/projectInfo/projectImport', '/api/evaluationPlan/planImport', '/api/projectInfo/matchProjectList', '/api/evaluationStandard/standardImport']
  return new Promise((resolve, reject) => {
    for (var i in options) {
      if (typeof options[i] == 'string') {
        options[i] = options[i].trim()
      }
    }
    let importData = options
    const axiosConfig = {
      method: type,
      url: url,
      //URLForAPI为独立项目取baseURL所用
      baseURL: apiUrl,
      params: type === 'get' ? options : null,
      data: type === 'post' ? JSON.stringify(options) : null,
      // responseType: downloadUrl.indexOf(url) > -1 ? 'blob' : 'application/json',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        token: getToken() ? getToken() : ''
        // AppId: process.env.APP_ID||"po246089zkljagiusdgq",
        // languageType: getLang()=='en'?'1':'0'
      }
    }
    if (baseURL) {
      axiosConfig.baseURL = baseURL
      axiosConfig.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
      // axiosConfig.transformRequest = [function (data) {
      //   return qs.stringify(data);
      //   // return data;
      // }];
      axiosConfig.data = qs.stringify(options)
      // axiosConfig.responseType = 'json';
      // axiosConfig.params = options;
      // delete axiosConfig.data;
      // delete axiosConfig.params;
      delete axiosConfig.headers.AppId
      delete axiosConfig.headers.token
      delete axiosConfig.headers.languageType
      // console.log("axiosConfig=",axiosConfig);
    }
    //不要直接写 否则老是警告
    const data = new FormData()
    if (downloadUrl.indexOf(url.split('?')[0]) > -1) {
      axiosConfig.responseType = 'blob'
    }
    if (importdUrl.indexOf(url.split('?')[0]) > -1) {
      data.append('file', importData.file)
      axiosConfig.data = data
      axiosConfig.headers['Content-Type'] = 'multipart/form-data'
    }
    const service = axios(axiosConfig)
      .then((res) => {
        // console.log("res=",res);
        //有些已经被处理拦截了
        if (res) {
          if (res.data.code !== 200 && downloadUrl.indexOf(url.split('?')[0]) < 0 && url !== '/api/evaluationPlan/deleteEvaluationPlanById') {
            _message('warning', res.data.msg)
            // 非成功状态下均提示（res.data.status != undefined过滤下载请求）
          }
          if (res.data.code === 200 && importdUrl.indexOf(url.split('?')[0]) > -1) {
            _message('success', res.data.msg)
          }

          if (res.data.type === 'application/json' && downloadUrl.indexOf(url.split('?')[0]) > -1) {
            const fileReader = new FileReader()
            fileReader.onload = function() {
              try {
                const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
                _message('warning', jsonData.msg)
                resolve(jsonData)
              } catch (err) {
                resolve(res.data)
              }
            }
            fileReader.readAsText(res.data)
            return
          }
          resolve(res.data)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  })
}

//
export default {
  /**
   * GET请求
   */
  get(url, options, baseURL) {
    return new Promise((resolve, reject) => {
      request('get', url, options, baseURL).then((data) => {
        resolve(data)
      })
    })
  },
  /**
   * POST请求
   */
  post(url, options, baseURL) {
    return new Promise((resolve, reject) => {
      request('post', url, options, baseURL).then((data) => {
        resolve(data)
      })
    })
  },
  apiUrl
}

//错误提示
function _message(t, m) {
  Message({
    type: t,
    message: m,
    center: true
  })
}



// WEBPACK FOOTER //
// ./src/api/common/httpRequest.js